import type {EnvironmentKind} from '@github-ui/agent-sessions-types/environment'

import {isQuickChatTask, type QuickChatTask} from './is-quick-chat-task'

export function isRepolessChatTask(task: QuickChatTask | null | undefined, repoNwo: string | undefined): boolean {
  return Boolean(task) && !isQuickChatTask(task) && !repoNwo
}

export function shouldUseEmbeddedSandboxPresentation(args: {
  isRepolessChatTask: boolean
  isAhpSession: boolean
  ahpEligibilityPending: boolean
  environmentKind: EnvironmentKind | undefined
}): boolean {
  return (
    args.isRepolessChatTask &&
    args.isAhpSession &&
    !args.ahpEligibilityPending &&
    args.environmentKind === 'managed-sandbox'
  )
}
